import React from "react";

function Footer() {
  return (
    <footer className="app-footer">
      Powered by Galactic Web
    </footer>
  );
}

export default Footer;
